var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 15,
    height: 16.6667,
    viewBox: "0 0 15 16.6667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5.78333C14.9913 5.70678 14.9746 5.63136 14.95 5.55833V5.48333C14.9099 5.39765 14.8565 5.31889 14.7917 5.25L9.79167 0.25C9.72278 0.18518 9.64402 0.131734 9.55833 0.0916667C9.53346 0.0881335 9.50821 0.0881335 9.48333 0.0916667C9.39868 0.0431178 9.30519 0.0119535 9.20833 0H5.83333C4.45262 0 3.33333 1.11929 3.33333 2.5V3.33333H2.5C1.11929 3.33333 0 4.45262 0 5.83333V14.1667C0 15.5474 1.11929 16.6667 2.5 16.6667H9.16667C10.5474 16.6667 11.6667 15.5474 11.6667 14.1667V13.3333H12.5C13.8807 13.3333 15 12.214 15 10.8333V5.83333C15 5.83333 15 5.83333 15 5.78333ZM10 2.84167L12.1583 5H10.8333C10.3731 5 10 4.6269 10 4.16667V2.84167ZM10 14.1667C10 14.6269 9.6269 15 9.16667 15H2.5C2.03976 15 1.66667 14.6269 1.66667 14.1667V5.83333C1.66667 5.3731 2.03976 5 2.5 5H3.33333V10.8333C3.33333 12.214 4.45262 13.3333 5.83333 13.3333H10V14.1667ZM13.3333 10.8333C13.3333 11.2936 12.9602 11.6667 12.5 11.6667H5.83333C5.3731 11.6667 5 11.2936 5 10.8333V2.5C5 2.03976 5.3731 1.66667 5.83333 1.66667H8.33333V4.16667C8.33333 5.54738 9.45262 6.66667 10.8333 6.66667H13.3333V10.8333Z",
    fill: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a0267ed1e0972de75fc0ff98ab8ce872.svg";
export { ForwardRef as ReactComponent };